/* eslint-disable */
// import { validation } from './commonValidation';

const resetPassword = () => {
  const form = document.querySelector('.js-pwd-reset-form');
  const form2 = document.querySelector('.js-pwd-reset-form2');
  const usrEmail = document.querySelector('.js-pwd-reset-mail');
  let usrEmailInput = null;
  if (usrEmail) {
    usrEmailInput = usrEmail.querySelector('input');
  }
  const pwdInputOld = document.querySelector('.js-change-pwd-old');
  const pwdInputNew = document.querySelector('.js-change-pwd-new');
  const submitBtn = document.querySelector('.js-change-pwd-submit');

  const validateEmail = () => {
    const emailLabel = document.querySelector('.js-validated-email-label');
    const emailInput = document.querySelector('.js-validated-email-input');
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!re.test(emailInput.value.toLowerCase())) {
      emailLabel.classList.add('has-error');
      return false;
    } else {
      emailLabel.classList.remove('has-error');
      return true;
    }
  };

  const sendAjax = e => {
    e.preventDefault();

    let ajaxData = {
      action: 'ks_pwd_reset',
      ks_user_mail: usrEmailInput.value,
    };

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');

    const ajax_url = document.querySelector('meta[name="adjx"]').content;
    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);
    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );
    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        let cards = document.querySelectorAll('.c-card');
        cards.forEach(element => {
          element.classList.add('u-hidden');
        });
        document
          .querySelector('.js-mail-send-success')
          .classList.remove('u-hidden');
      }
    };
    request.onerror = function() {};
    request.send(ajaxParameters);
  };

  const sendSecondAjax = e => {
    e.preventDefault();
    if(!checkPassword()) {
      return;
    }
    const password = document.querySelector('.js-validated-password-input');
    var url = new URL(window.location.href);
    var registration_email = url.searchParams.get('registration_email');
    let ajaxData = {
      action: 'ks_pwd_reset2',
      ks_user_mail: registration_email,
      ks_new_pass: password.value,
    };

    let ajaxParameters = Object.entries(ajaxData)
      .map(e => e.join('='))
      .join('&');

    const ajax_url = document.querySelector('meta[name="adjx"]').content;
    let request = new XMLHttpRequest();
    request.open('POST', ajax_url, true);
    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded;',
    );
    request.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        let cards = document.querySelectorAll('.c-card');
        cards.forEach(element => {
          element.classList.add('u-hidden');
        });
        document.querySelector('.js-pass-success').classList.remove('u-hidden');
      }
    };
    request.onerror = function() {};
    request.send(ajaxParameters);
  };

  function hasLowerCase(str) {
    return str.toUpperCase() != str;
  }
  function hasUpperCase(str) {
    return str.toLowerCase() != str;
  }
  function checkPassword(e) {
    const password = document.querySelector('.js-validated-password-input');
    let validConditions = 0;
    if (password.value.length >= 8) {
      document.querySelector('.js-pwd-length').setAttribute('data-valid', '1');
      validConditions += 1;
    } else {
      document.querySelector('.js-pwd-length').setAttribute('data-valid', '0');
    }
    if (hasLowerCase(password.value)) {
      document
        .querySelector('.js-pwd-small-letter')
        .setAttribute('data-valid', '1');
        validConditions += 1;
    } else {
      document
        .querySelector('.js-pwd-small-letter')
        .setAttribute('data-valid', '0');
    }
    if (hasUpperCase(password.value)) {
      document
        .querySelector('.js-pwd-big-letter')
        .setAttribute('data-valid', '1');
        validConditions += 1;
    } else {
      document
        .querySelector('.js-pwd-big-letter')
        .setAttribute('data-valid', '0');
    }
    let format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (format.test(password.value)) {
      document
        .querySelector('.js-pwd-special-letter')
        .setAttribute('data-valid', '1');
        validConditions += 1;
    } else {
      document
        .querySelector('.js-pwd-special-letter')
        .setAttribute('data-valid', '0');
    }
    if (validConditions !== 4) {
      password.closest('label').classList.add('has-error');
      return false;
    } else {
      password.closest('label').classList.remove('has-error');
      return true;
    }
  }
  const pwdResetValidation = e => {
    e.preventDefault();
    if (validateEmail()) {
      sendAjax(e);
    }
  };

  if (form) {
    form.addEventListener('submit', pwdResetValidation);
    const mailInput = document.querySelector('.js-mail-input');
    usrEmail.addEventListener('keyup', () => {
      validateEmail();
      mailInput.innerHTML = usrEmailInput.value;
    });
  }
  if (form2) {
    const password = document.querySelector('.js-validated-password-input');
    password.addEventListener('keyup', checkPassword);
    form2.addEventListener('submit', sendSecondAjax);
  }
};

export default resetPassword;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/resetPassword.js